import React, { useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import {} from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { getEntity } from './aidas-user.reducer';
import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

export const AidasUserDetail = (props: RouteComponentProps<{ id: string }>) => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(getEntity(props.match.params.id));
  }, []);

  const aidasUserEntity = useAppSelector(state => state.aidasUser.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="aidasUserDetailsHeading">AidasUser</h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">ID</span>
          </dt>
          <dd>{aidasUserEntity.id}</dd>
          <dt>
            <span id="firstName">First Name</span>
          </dt>
          <dd>{aidasUserEntity.firstName}</dd>
          <dt>
            <span id="lastName">Last Name</span>
          </dt>
          <dd>{aidasUserEntity.lastName}</dd>
          <dt>
            <span id="email">Email</span>
          </dt>
          <dd>{aidasUserEntity.email}</dd>
          <dt>
            <span id="locked">Locked</span>
          </dt>
          <dd>{aidasUserEntity.locked ? 'true' : 'false'}</dd>
          <dt>
            <span id="password">Password</span>
          </dt>
          <dd>{aidasUserEntity.password}</dd>
          <dt>Aidas Organisation</dt>
          <dd>{aidasUserEntity.aidasOrganisation ? aidasUserEntity.aidasOrganisation.name : ''}</dd>
          <dt>Aidas Customer</dt>
          <dd>{aidasUserEntity.aidasCustomer ? aidasUserEntity.aidasCustomer.name : ''}</dd>
          <dt>Aidas Vendor</dt>
          <dd>{aidasUserEntity.aidasVendor ? aidasUserEntity.aidasVendor.name : ''}</dd>
        </dl>
        <Button tag={Link} to="/aidas-user" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" /> <span className="d-none d-md-inline">Back</span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/aidas-user/${aidasUserEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" /> <span className="d-none d-md-inline">Edit</span>
        </Button>
      </Col>
    </Row>
  );
};

export default AidasUserDetail;
